"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var idlUtils = require("../generated/utils.js");

exports.implementation =
/*#__PURE__*/
function (_Array) {
  _inherits(FileListImpl, _Array);

  function FileListImpl() {
    _classCallCheck(this, FileListImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(FileListImpl).call(this, 0));
  }

  _createClass(FileListImpl, [{
    key: "item",
    value: function item(index) {
      return this[index] || null;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      return this.keys();
    }
  }]);

  return FileListImpl;
}(_wrapNativeSuper(Array));